import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {
  AM_ACTION,
  AM_ATTACHMENT_TYPE,
  AM_ATTACHMENT_TYPE_TO_EDIT,
  AM_ATTRIBUTE_TO_EDIT,
  AM_MODULE_NAMESPACE
} from '../../../store/agency-management'
import {TranslateResult} from 'vue-i18n'
import {USER_ACTION_TYPE, USER_MODULE_NAMESPACE} from '../../../store/user/user-types.store';
import {CrudStatus} from '../../../common/enums';
import { AgencyManagementService } from '../../../services'

const AMStore = namespace(AM_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE)

@Component({
  components: {
    'crud-menu': async () => import('@/components/crud-menu/CrudMenu.vue')
  }
})
class AttachmentTypeDetail extends Vue {
  /* eslint-disable no-undef */
  @AMStore.Action(AM_ATTACHMENT_TYPE)
  storeGetAttachmentType: (id: string) => Promise<any>
  @AMStore.Action(AM_ATTACHMENT_TYPE_TO_EDIT)
  storeEditAttachmentType: () => void
  @AMStore.Action(AM_ATTRIBUTE_TO_EDIT)
  storeEditAttribute: (attribute) => void

  @AMStore.Getter attachmentType: any

  @UserStore.Mutation(USER_ACTION_TYPE)
  storeSetUserActionType: (type: string) => void

  @AMStore.Mutation(AM_ACTION)
  storeSetCRUDActionStatus: (action: CrudStatus) => void

  breadcrumbs: {text: TranslateResult, disabled: boolean, href: string}[]
  _timeout: any
  dtMessageErrorModel: boolean
  dtError: any
  dtDeleteCharPb: boolean
  dtIsLoading: boolean
  AMService: AgencyManagementService

  constructor () {
    super()
    this.breadcrumbs = []
    this.dtMessageErrorModel = false
    this.dtError = null
    this.dtDeleteCharPb = false
    this.dtIsLoading = false
    this.AMService = new AgencyManagementService()
  }

  created () {
    this.loadPage()
    this.$watch('$route.params', ({ id }) => {
      this.loadPage()
    })
  }

  mounted () {}

  get lblSetting () {
    return {
      ...require('@/locales/agency-management').default,
      ...require('@/locales/profile').default
    }
  }

  get coMenuTexts () {
    return {
      edit: this.attachmentType.level === 1 ? this.$t(this.lblSetting.amCharPbEdit) : this.$t(this.lblSetting.amCharPb2Edit),
      delete: this.attachmentType.level === 1 ? this.$t(this.lblSetting.amCharPbDelete) : this.$t(this.lblSetting.amCharPb2Delete)
    }
  }

  get coMenuAuths (): { edit: boolean, delete: boolean } {
    return Object.assign({}, {
      edit: this.$route.meta['manage_agency_attachment_type'] && !this.attachmentType.locked,
      delete: this.$route.meta['manage_agency_attachment_type']
    })
  }

  get isDisabled () {
    if (!this.attachmentType) return false
    return !this.attachmentType.enabled
  }

  get avatarColor (): string {
    if (this.isDisabled) return '#848484'
    return 'primary'
  }

  get avatarLink (): string {
    if (this.isDisabled) return this.attachmentType.icon_grey
    return this.attachmentType.icon
  }

  get levelFormatted () {
    if (!this.attachmentType) return ''
    return this.attachmentType.level === 1 ? this.$t(this.lblSetting.amCharPbLevel1) : this.$t(this.lblSetting.amCharPbLevel2)
  }

  get displayCard () {
    if (!this.attachmentType) return false
    if (this.attachmentType.level === 1 &&
      this.attachmentType.level_2.length > 0) return true
    if (this.attachmentType.level === 2 && this.attachmentType.attributes.length > 0) return true
    return false
  }

  get displayLvl2 () {
    if (!this.attachmentType) return false
    return this.attachmentType.level === 1 &&
      this.attachmentType.level_2.length > 0
  }

  get displayAttributes () {
    if (!this.attachmentType) return false
    if (this.attachmentType.locked && this.attachmentType.attributes.length === 0) return false
    return this.$route.meta['view_attachment_attribute']
  }

  get coDeleteMessage () {
    return this.attachmentType.level === 1 ?
      this.$t(this.lblSetting.amDeleteCharPbMsg, {char_pb: this.attachmentType.name}) :
      this.$t(this.lblSetting.amDeleteCharPb2Msg, {char_pb: this.attachmentType.name})
  }

  level2Color (item) {
    if (item.enabled) return 'primary'
    return '#848484'
  }

  level2Icon (item) {
    if (item.enabled) return item.icon
    return item.icon_grey
  }

  loadPage () {
    this.storeGetAttachmentType(this.$route.params.id).then(res => {
      this.breadcrumbs = [
        {text: this.$t(this.lblSetting.profileAgencyManagementBtn), disabled: false, href: '/profile/attachment-type'}
      ]
      if (this.attachmentType.level === 1) this.breadcrumbs.push({
        text: this.attachmentType.name,
        disabled: true,
        href: ''
      })
      if (this.attachmentType.level === 2) {
        this.breadcrumbs.push({
          text: this.attachmentType.parent.name,
          disabled: false,
          href: '/profile/attachment-type/'+this.attachmentType.parent.id
        }, {
          text: this.attachmentType.name,
          disabled: true,
          href: ''
        })
      }
    })
  }

  handleCloseErrorModal () {
    this.dtError = null
    this.dtMessageErrorModel = false
  }

  handleDeleteCancel () {
    this.dtDeleteCharPb = false
  }

  handleMenuDelete () {
    this.dtDeleteCharPb = true
  }

  confirmDeleteCharPb () {
    this.dtIsLoading = true
    this.AMService.deleteAttachmentType(this.attachmentType.id).then(rs=>{
      if(this.attachmentType.level===2)
      {
        this.$router.replace(`/profile/attachment-type/${this.attachmentType.fk_doc_type_parent}`)
      } else {
        this.$router.replace(`/profile/attachment-type`)
      }
    }).catch(err => {
      this.dtMessageErrorModel = true
      this.dtError = err
    })
    .finally(() => {
      this.dtIsLoading = false
      this.dtDeleteCharPb = false
    })

  }

  handleMenuEdit () {
    this.storeSetUserActionType('ATTACHMENT_TYPE')
    this.storeEditAttachmentType()
  }

  handleEditAttribute (attribute) {
    this.storeSetUserActionType('AT_ATTRIBUTE')
    this.storeEditAttribute(attribute)
  }

  handleAddAttribute () {
    this.storeSetUserActionType('AT_ATTRIBUTE')
    this.storeSetCRUDActionStatus(CrudStatus.Create)
  }
}

export default AttachmentTypeDetail



// WEBPACK FOOTER //
// ./src/containers/profile/attachment-type-detail/index.ts